module.exports = "<span class=\"snack-bar\">\r\n        {{data.message}}\r\n</span>\r\n"